var TyreCatalog = (function ($) {

    function initialize() {
        $("#selectProducts").on("change",function(){
            var selectedProduct = $(this).val();

            $.ajax({
                type: "GET",
                url: "/catalog/profile/product/related-moto",
                beforeSend: function (xhr) {
                    xhr.setRequestHeader("X-CSRF-TOKEN", $("input[name='_csrf']").val());
                },
                data: {
                    productCode: selectedProduct
                },
                success: function (data) {
                    var relatedMotoPanel = $("#content_relatedmotopanels");
                    var relatedMotoTab =$("#relatedmotopanels_tab");
                    relatedMotoTab.removeClass("active");
                    relatedMotoPanel.remove();
                    relatedMotoTab.after(data);
                    $('.matching-pagination-element').on('click', function(e) {
                        MOTO_SEARCH.displayPaginatedElementAt(e.target);
                    });
                }
            });
        });
    }

    return{
        initialize: initialize
    };

})($);

$(document).ready(function () {
    TyreCatalog.initialize();
});